// extracted by mini-css-extract-plugin
export default {"segmentOptions":"AccessibleRouteSegmented_segmentOptions__YDcpi"};